
WB.Components = WB.Components || {};

WB.Components.PageLayoutDirectiveLink = function($route, PageLayoutsDataManager, GlobalClassUtility) {

    return function (scope) {

        var onAliasUpdate = function(alias, oldAlias) {
            GlobalClassUtility.toggleClass('no-page-layout', !alias);
            scope.loadingLayout = false;
            scope.errorLoadingLayout = false;

            if (alias === oldAlias && scope.initialLoadComplete) {
                return;
            }
            if (!alias) {
                scope.pageLayout = null;
                return;
            }

            scope.showTempStories = true;
            if (alias === 'Forecasts-Pages'
            || alias === 'Forecasts-Hourly-Pages'
            || alias === 'Forecasts-Daily-Pages' ) {
                scope.showTempStories = false;
            }

            scope.loadingLayout = true;
            scope.pageLayout = null;
            
            PageLayoutsDataManager.GetPageLayoutForAlias(alias)
                .then(function(layout) {
                    scope.pageLayout = layout;
                })
                .catch(function(err) {
                    scope.errorLoadingLayout = true;
                })
                .finally(function() {
                    scope.loadingLayout = false;
                    scope.initialLoadComplete = true;
                });
        };

        scope.$watch('pageLayoutAlias', onAliasUpdate);
    };
};

WB.Components.PageLayoutDirective = function($route, PageLayoutsDataManager, GlobalClassUtility) {
    return {
        scope: {
            pageLayoutAlias: '='
        },
        restrict: 'AE',
        link: WB.Components.PageLayoutDirectiveLink($route, PageLayoutsDataManager, GlobalClassUtility),
        template: `<div ng-if="pageLayout.WidgetGrids.length > 0 || loadingLayout || errorLoadingLayout" class="widget-grids js-widget-grids">
        <section class="widget-grids js-widget-grids">
            <ul class="widget-grid-list block-list"
                ng-if="pageLayout.WidgetGrids.length > 0">

                <li class="widget-grid-list__item"
                    ng-repeat="grid in pageLayout.WidgetGrids">
                    <section class="section widget-grid-section">
                        <div class="container">
                            <header class="widget-grid__heading"
                                ng-if="grid.Headline || grid.Subline">
                                <h1 class="widget-grid__headline"
                                    ng-bind="grid.Headline"></h1>
                                <h2 class="widget-grid__subline"
                                    ng-if="grid.Subline"
                                    ng-bind="grid.Subline"></h2>
                            </header>
                            <div class="widget-grid-wrapper">
                                <div
                                    wb-widget-grid
                                    grid="grid"></div>
                                    <div
                                        ng-if="!$root.App.config.Taboola.Disabled
                                            && $root.App.config.TaboolaPages
                                            && $root.App.config.TaboolaPages.includes($root.ActiveRoute.locals.pageId)
                                            && grid.LayoutId != 1 && grid.LayoutId != 3"
                                    >
                                        <widget-taboola-ad
                                            height="250"
                                            width="300"
                                        />
                                    </div>
                            </div>
                        </div>
                    </section>
                </li>
            </ul>

            <div class="module-loader block-loader is-clear"
                wb-preloader color="#444"
                ng-if="loadingLayout"
                ng-cloak>
            </div>

            <div class="module-error is-large is-dark"
                ng-if="errorLoadingLayout" ng-cloak>
                <div class="module-error__box">
                    <span class="icon">
                        <svg>
                            <use xlink:href="/dist/img/ui/cloud-error.svg"></use>
                        </svg>
                    </span>
                    <div class="message">
                        Weather Data Not Available
                    </div>
                </div>
            </div>
        </section>
    </div>`
    };
};
WB.Components.PageLayoutDirective.$inject = ['$route', 'PageLayoutsDataManager', 'GlobalClassUtility'];

WB.App.directive('wbPageLayout', WB.Components.PageLayoutDirective);
